import { CloseButton, Flex, Grid, GridItem, Text } from '@chakra-ui/react';
import ModalTemplate from '@components/modalTemplate';
import { Fragment } from 'react';

const BundleModal = ({ isOpen, onClose, bundleData }) => {
    const MODAL_WIDTH = '728px';
    const MODAL_CONTENT_STYLE = { maxHeight: '80vh', overflowY: 'auto' };

    return (
        <ModalTemplate
            width={MODAL_WIDTH}
            isOpen={isOpen}
            onClose={onClose}
            modalContentCustomStyle={MODAL_CONTENT_STYLE}
        >
            <Flex
                width="100%"
                p="24px"
                flexDirection="column"
                alignItems="flex-start"
                justifyContent="center"
                gap="32px"
            >
                <Flex alignItems="center" justifyContent="space-between">
                    <Text fontSize="24px" fontWeight={700}>
                        Daftar Produk
                    </Text>
                    <CloseButton onClick={onClose} />
                </Flex>
                <Grid width="100%" templateColumns="1fr 4fr" gap="16px" paddingRight="32px">
                    <GridItem>
                        <Text fontWeight={700}>Name Bundle</Text>
                    </GridItem>
                    <GridItem>
                        <Text>{bundleData?.name}</Text>
                    </GridItem>
                    <GridItem>
                        <Text fontWeight={700}>Customer Code</Text>
                    </GridItem>
                    <GridItem>
                        <Text>{bundleData?.code ?? bundleData?.barcode}</Text>
                    </GridItem>
                    <GridItem>
                        <Text fontWeight={700}>Produk Paragon</Text>
                    </GridItem>
                    <GridItem>
                        <Grid templateColumns="1fr minmax(36px, auto)" columnGap="8px" rowGap="4px">
                            {bundleData?.product_list?.length > 0 ? (
                                bundleData?.product_list?.map((product, index) => (
                                    <Fragment key={index}>
                                        <Text>{product.name}</Text>
                                        <Text textAlign="right" wordBreak="keep-all" minWidth="fit-content">
                                            x {(Number(product.qty) || 0).toLocaleString('id-ID')}
                                        </Text>
                                    </Fragment>
                                ))
                            ) : (
                                <Text>-</Text>
                            )}
                        </Grid>
                    </GridItem>
                </Grid>
            </Flex>
        </ModalTemplate>
    );
};

export default BundleModal;
